import React from 'react';
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../state/AuthContext";
import { CONST_ROUTE_PATH } from './RouteConstants';

/**
 * Handles route authentication
 * @param {*} param0 
 * @returns 
 */
const ProtectedRoute = () => {
    const { apiToken, backendToken } = useAuth()

    return (apiToken || backendToken) ? <Outlet /> : <Navigate to={CONST_ROUTE_PATH.SIGN_IN} />
}

export default ProtectedRoute;